import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanDeactivate,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from 'src/app/_services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard
  implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkPermission(next, state);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(next, state);
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  checkPermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // verificam daca exista autentificare si permisiuni pentru a ajunge la ruta dorita
    if (this.authenticationService.isOnlyAuthenticated()) {
      let isOk = true;
      const accountRoles = this.authenticationService.getRoles();

      if (accountRoles) {
        for (const role of accountRoles) {
          if (route.data.role === undefined || (route.data.role && route.data.role.indexOf(role.mapping) > -1)) {
            return true;
          } else {
            isOk = false;
          }
        }

        // daca nu exista permsiuni, facem redirectionare o la pagina in acest scop
        if (!isOk) {
          return this.router.parseUrl("/authentication/page401");
        }
      }

      return true;
    }

    // nu exista user autentificat, drept urma se va face redirect la pagina de autentificare
    return this.router.parseUrl("/authentication/signin");
  }
}
